import { useEffect, useState, useCallback, type PropsWithChildren } from 'react'
import { useLocation } from 'react-router'
import { useMandatoryAssessmentRequired } from '@/hooks/useMandatoryAssessmentRequired'
import { ROUTES, isGuardExcludedPath } from '@/constants/routes'
import { MandatoryAssessmentModal } from './MandatoryAssessmentModal'

export function MandatoryAssessmentGuard({ children }: PropsWithChildren) {
  const location = useLocation()
  const { shouldShowMandatoryAssessment, isLoading } = useMandatoryAssessmentRequired()
  const [showModal, setShowModal] = useState(false)
  const [hasBeenDismissed, setHasBeenDismissed] = useState(false)

  useEffect(() => {
    if (isLoading) return

    if (shouldShowMandatoryAssessment) {
      setHasBeenDismissed(false)
      setShowModal(true)
    } else {
      setShowModal(false)
    }
  }, [shouldShowMandatoryAssessment, isLoading, location.pathname])

  const handleOpenChange = useCallback((open: boolean) => {
    if (!open) {
      setHasBeenDismissed(true)
    }
    setShowModal(open)
  }, [])

  const shouldDisplayModal = showModal && !hasBeenDismissed
  const isOnExcludedPage = location.pathname === ROUTES.PERFORMANCE || isGuardExcludedPath(location.pathname)

  return (
    <>
      {shouldDisplayModal && !isOnExcludedPage && (
        <MandatoryAssessmentModal open={shouldDisplayModal} onOpenChange={handleOpenChange} />
      )}
      {children}
    </>
  )
}
